var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeopleOperations = function SvgPeopleOperations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.027 30.034a9.017 9.017 0 1 0-6.467-2.733l-2.158 2.313a.25.25 0 0 0 .183.42h8.442Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.021 11.78A10.966 10.966 0 0 1 11.027 10c6.085 0 11.017 4.932 11.017 11.017 0 1.22-.198 2.394-.564 3.49C26.848 23 30.773 18.195 30.773 12.5a12.21 12.21 0 0 0-2.765-7.738L32 0H17.887C11.019 0 5.407 5.211 5.02 11.78Z",
    clipRule: "evenodd",
    opacity: 0.4
  })));
};
export default SvgPeopleOperations;